"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMetaKeyPressed = exports.numericKeys = exports.movementKeys = exports.deleteKeys = void 0;

/* eslint-disable no-magic-numbers, line-comment-position, no-inline-comments */
var deleteKeys = [8, // backspace
46 // delete
];
exports.deleteKeys = deleteKeys;
var movementKeys = [9, // tab
16, // shift
37, // arrow left
38, // arrow up
39, // arrow right
40 // arrow down
];
exports.movementKeys = movementKeys;
var numericKeys = [48, // row 0
49, // row 1
50, // row 2
51, // row 3
52, // row 4
53, // row 5
54, // row 6
55, // row 7
56, // row 8
57, // row 9
96, // numPad 0
97, // numPad 1
98, // numPad 2
99, // numPad 3
100, // numPad 4
101, // numPad 5
102, // numPad 6
103, // numPad 7
104, // numPad 8
105 // numPad 9
];
exports.numericKeys = numericKeys;

var isMetaKeyPressed = function isMetaKeyPressed(event) {
  return event.ctrlKey || event.altKey || event.metaKey;
};

exports.isMetaKeyPressed = isMetaKeyPressed;